if (!customElements.get('gallery-images')) {
  class GalleryImages extends HTMLElement {
    connectedCallback() {
      this.init();

      this.modal = this.querySelector('.modal.lightbox-modal');
      this.modalImage = this.querySelector('.lightbox-modal .modal-image');
      this.closeModalButton = this.querySelector('.lightbox-close');
      this.galleryItems = this.querySelectorAll('.gallery-detail__item-image[data-zoom-img]');
      this.prevImageButton = this.querySelector('.lightbox-modal .left-arrow');
      this.nextImageButton = this.querySelector('.lightbox-modal .right-arrow');

      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleLightbox();
      this.handleClose();

      if (this.modal) {
        document.addEventListener('keydown', this.handleKeydown);
      }
    }

    disconnectedCallback() {
      if (this.modal) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
    }

    init() {
      this.galleryDetail = this.querySelector('.gallery-detail');
      if (!this.galleryDetail) return;
      this.imagesContainer = this.querySelector('.gallery-detail__images');

      if (this.imagesContainer) {
        this.initMacy();
      }
    }

    initMacy() {
      Macy({
        container: this.imagesContainer,
        trueOrder: true,
        waitForImages: false,
        margin: 16,
        columns: 4,
        breakAt: {
          1200: 3,
          940: 2,
          520: 1
        }
      });
    }

    handleLightbox() {
      if (!this.modal || !this.modalImage || !this.closeModalButton || !this.galleryItems.length) {
        return;
      }

      let images = []
      let currentIndex = -1

      this.galleryItems.forEach((item, index) => {
        const zoomImageUrl = item.dataset.zoomImg;
        if (zoomImageUrl) {
          images.push(zoomImageUrl);
        }

        item.addEventListener('click', (event) => {
          event.preventDefault();
          currentIndex = index
          this.modalImage.src = images[currentIndex]
          this.modal.style.display = "flex"
        });
      });

      this.prevImageButton.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex--
          this.modalImage.src = images[currentIndex]
        } else {
          currentIndex = images.length - 1
          this.modalImage.src = images[currentIndex]
        }
      });

      this.nextImageButton.addEventListener("click", () => {
        if (currentIndex < images.length - 1) {
          currentIndex++
          this.modalImage.src = images[currentIndex]
        } else {
          currentIndex = 0
          this.modalImage.src = images[currentIndex]
        }
      })
    }

    handleClose() {
      if (!this.modal || !this.closeModalButton) return;

      this.closeModalButton.addEventListener('click', () => {
        this.modal.style.display = 'none';
      });

      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.modal.style.display = 'none';
        }
      });
    }

    handleKeydown(event) {
      if (!this.modal) return;

      if (this.modal.style.display === 'flex') {
        if (event.key === 'ArrowLeft' || event.keyCode === 37) {
          this.prevImageButton.click()
        }
        else if (event.key === 'ArrowRight' || event.keyCode === 39) {
          this.nextImageButton.click()
        }
        else if (event.key === 'Escape' || event.keyCode === 27) {
          this.closeModalButton.click()
        }
      }
    }
  }

  customElements.define('gallery-images', GalleryImages);
}